export enum TRACKING_EVENT_NAMES {
  errorScreenDisplayed = 'errorScreenDisplayed',
  noEntitlementsFound = 'noEntitlementsFound',
  noSitesFound = 'noSitesFound',
  showAllLinkDisplayed = 'showAllLinkDisplayed',
  showAllLinkClicked = 'showAllLinkClicked',
  wacCartAddPaymentDetailsButtonClicked = 'wacCartAddPaymentDetailsButtonClicked',
  wacCartIconClicked = 'wacCartIconClicked',
  wacCartPopoverClosed = 'wacCartPopoverClosed',
  wacCartPopoverViewed = 'wacCartPopoverViewed',
  wacCartRendered = 'wacCartRendered'
}

export enum ACTION_SUBJECT_IDS {
  wacCartRendered = 'wacCartRendered',
  wacCartPopoverErrorScreen = 'wacCartPopoverErrorScreen',
  wacCartShowAllLinkDisplayed = 'wacCartShowAllLinkDisplayed',
  wacCartShowAllLinkClicked = 'wacCartShowAllLinkClicked',
  wacCartFeatureExposed = 'wacCartFeatureExposed',
  wacCartEstimateCallFailed = 'wacCartEstimateCallFailed',
  wacCartUseEntitlementsFailed = 'wacCartUseEntitlementsFailed',
  wacCartUseEntitlementListingsFailed = 'wacCartUseEntitlementListingsFailed',
  wacCartInvoiceGroupsCallFailed = 'wacCartInvoiceGroupsCallFailed',
  wacCartProductHubInfoReturnedNoSites = 'wacCartProductHubInfoReturnedNoSites',
  wacCartProductHubInfoReturnedNoEntitlements = 'wacCartProductHubInfoReturnedNoEntitlements',
  wacCartIcon = 'wacCartIcon',
  wacCartPopover = 'wacCartPopover',
  wacCartPopoverClosed = 'wacCartPopoverClosed'
}
